import type { IconType } from '@kognitos/lattice';
import {
  V1InvocationSource,
  type V1InvocationDetails,
} from '@/generated/hooks/jeeves/models';
import { EMAIL_BOOK_NAME } from '@/modules/triggers/components/EmailTriggerDialog/constants';

/**
 * Maps invocation source enum values to their display information.
 * Used to render badges showing how a run was triggered.
 * Labels use i18n keys from the 'automation' namespace.
 */
export const INVOCATION_SOURCE_BADGE_INFO: Record<
  string,
  { labelKey: string; icon: IconType }
> = {
  [V1InvocationSource.INVOCATION_SOURCE_MANUAL]: {
    labelKey: 'automation.run.invocationSource.manual',
    icon: 'UserRound',
  },
  [V1InvocationSource.INVOCATION_SOURCE_SCHEDULE]: {
    labelKey: 'automation.run.invocationSource.schedule',
    icon: 'Calendar',
  },
  [V1InvocationSource.INVOCATION_SOURCE_TRIGGER]: {
    labelKey: 'automation.run.invocationSource.trigger',
    icon: 'Mail',
  },
  [V1InvocationSource.INVOCATION_SOURCE_PAT]: {
    labelKey: 'automation.run.invocationSource.pat',
    icon: 'Key',
  },
  [V1InvocationSource.INVOCATION_SOURCE_UNSPECIFIED]: {
    labelKey: 'automation.run.invocationSource.unspecified',
    icon: 'HelpCircle',
  },
};

// Email arrives as a generic TRIGGER source, so it's identified by its trigger
// ID. Trigger IDs are book-prefixed ("github-wqsm2-trigger-…"), so the book is
// the first segment and is matched exactly: an unrelated book that merely
// contains the word ("salesforce-emailed-lead") is not an email trigger.
export const isEmailInvocation = (
  invocationDetails?: V1InvocationDetails,
): boolean =>
  invocationDetails?.invocation_source ===
    V1InvocationSource.INVOCATION_SOURCE_TRIGGER &&
  invocationDetails?.trigger_id?.toLowerCase().split('-')[0] ===
    EMAIL_BOOK_NAME;
